// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as PorterStoreProductDetailEntityMapper from "../entity-mapper/PorterStoreProductDetailEntityMapper.bs.js";

var execute = PorterStoreProductDetailEntityMapper.execute;

var PorterStoreProductDetailConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var PorterStoreProductDetailResponseConverter = partial_arg(PorterStoreProductDetailConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  PorterStoreProductDetailConfig ,
  PorterStoreProductDetailResponseConverter ,
  
}
/* PorterStoreProductDetailResponseConverter Not a pure module */
